module.exports = __webpack_public_path__ + "images/pages/lp/comment_balloon_6_b726b5d1e12d3b5879a7b893c3eef634.png";